import Units from "../../../utils/Units";

let gridColor = "rgba(0, 0, 0, 0.1)";
let tickFontSize = 10;

let StaticAxis = {
    id: "static-axis",

    beginAtZero: true,
    min: 0,
    max: 10,
    maxTicksLimit: 10,
    precision: 0,
    showLines: false,
    display:false,

    gridLines: {
        showLines: false,
        color: gridColor,
        zeroLineColor: "rgba(0, 0, 0, 0)"
    },
    ticks: {
        min:0,
        max:10,
        fontSize: tickFontSize,
        beginAtZero:true,

        callback: (value, index, values) => {
            //return new Date(value).getDate();
            return value;
        }
    }
};

export default StaticAxis;



// WEBPACK FOOTER //
// ./src/components/chart/axes/StaticAxis.js